import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
} from "firebase/firestore";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import AddIcon from "@mui/icons-material/Add";
import { useSnackbar } from "notistack";
import { sCategory, sFeed, sName } from "../Strings";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function AddFeedModal({ open, setOpen, row }) {
  // const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const categoryRef = query(collection(db, sCategory), orderBy(sName));

  const { enqueueSnackbar } = useSnackbar();
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = React.useState([]);
  const feedRef = collection(db, sFeed);

  const [values, setValues] = React.useState({
    name: "",
    sub: "",
    imageUrl: "",
    sort: 0,
    status: 0,
    cid: [],
  });

  useEffect(() => {
    if (row) {
      setValues(row);
      console.log(row);
    }
    // get headings docs
    getDocs(categoryRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setCategory(data);
    });
  }, []);

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: parseInt(event.target.value)
        ? parseInt(event.target.value)
        : event.target.value,
    });
  };

  // set category
  const setDocData = () => {
    // Add a new document with a generated id.
    addDoc(feedRef, values).then(() => {
      setOpen(false);
      enqueueSnackbar("Section Added!", { variant: "success" });
    });
  };

  /*  // selecting category
  const handleChangeSelect = (event) => {
    setSCategory(event.target.value);
    values.parent = event.target.value;
  }; */

  const handleChangeSelect = (event) => {
    const {
      target: { value },
    } = event;

    // add selected category id to array
    values.cid = event.target.value;

    setSelectedCategory(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <div>
      <div>
        <Button
          onClick={handleOpen}
          variant="outlined"
          disableElevation
          startIcon={<AddIcon />}
          sx={{ width: 200, height: 40, borderRadius: 1, mt: 1, mb: 1 }}
        >
          Add Section
        </Button>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Typography variant="h6" component="h2" sx={{ mb: 3 }}>
              Add Feed Section
            </Typography>

            <Box sx={{ width: "100%", mb: 3 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Category</InputLabel>
                <Select
                  size="small"
                  value={selectedCategory}
                  label="Category"
                  multiple
                  onChange={handleChangeSelect}
                >
                  {category.map((value, key) => (
                    <MenuItem key={key} value={value.id}>
                      {value.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <TextField
              size="small"
              sx={{ mb: 3, width: "100%" }}
              label="Section Title"
              value={values.name}
              type="text"
              variant="outlined"
              onChange={handleChange("name")}
            />

            <TextField
              size="small"
              sx={{ mb: 3, width: "100%" }}
              label="Sub-title"
              value={values.sub}
              type="text"
              variant="outlined"
              onChange={handleChange("sub")}
            />

            <TextField
              size="small"
              sx={{ mb: 3, width: "100%" }}
              label="Sort"
              type="number"
              value={values.sort}
              variant="outlined"
              onChange={handleChange("sort")}
            />

            <Button
              onClick={setDocData}
              variant="contained"
              disableElevation
              sx={{ width: "100%", height: 50, borderRadius: 2 }}
            >
              Submit
            </Button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
